
export const SearchButton = () => {


  return (
    <>
      {/* <Tooltip
enterTouchDelay={0}
  leaveTouchDelay={10000} title="Search">
        <IconButton onClick={dialog.handleOpen}>
          <SvgIcon>
            <SearchMdIcon />
          </SvgIcon>
        </IconButton>
      </Tooltip>
      <SearchDialog
        onClose={dialog.handleClose}
        open={dialog.open}
      /> */}
    </>
  );
};
